export default "__VITE_ASSET__BX5a8adJ__"